import { render, staticRenderFns } from "./MapboxBlock.vue?vue&type=template&id=3843b9bd&"
import script from "./MapboxBlock.vue?vue&type=script&lang=js&"
export * from "./MapboxBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MapboxBlock.vue"
export default component.exports